/**
 * Products page tabs (D37; Brands D39; Size charts MERCH-88): which list each tab shows, the permission it needs
 * and, with `needs`, the store fact it also needs (size charts: a type sold by size is on).
 */
export const PRODUCT_TABS = [
  { key: 'listed', label: 'Listed', module: 'catalog', action: 'view' },
  { key: 'stock', label: 'In stock', module: 'inventory', action: 'view' },
  { key: 'models', label: 'Models', module: 'catalog', action: 'view' },
  { key: 'brands', label: 'Brands', module: 'catalog', action: 'view' },
  { key: 'size_charts', label: 'Size charts', module: 'catalog', action: 'view', needs: 'sized' },
];

/** The tabs this user may open, in order. `can(module, action)` is useCan()'s checker; `facts`: { sized }. */
export const visibleTabs = (tabs, can, facts = {}) => tabs.filter((t) => can(t.module, t.action) && (!t.needs || Boolean(facts[t.needs])));
